import {useEffect, useState} from 'react';
import type {Session} from '../types/modules';
import {useAuth} from '../context/AuthContext';

const DEFAULT_AVATAR = 'https://avatars.githubusercontent.com/u/19550456';

export function useSession() {
    const {user, email} = useAuth();

    const [session, setSession] = useState<Session | null>(null);

    useEffect(() => {
        const displayName = user || email;
        if (displayName) {
            setSession({
                user: {
                    name: displayName,
                    email: email || user || '',
                    image: DEFAULT_AVATAR,
                },
            });
        }
    }, [user, email]);

    return session;
}
